<template>
    <div class="fill-height of-y d-flex flex-column">

        <div v-show="false">
            {{displayMarkers}}
        </div>

        <div class="text-subtitle-1 d-flex align-center justify-center" >

            <div class="flex-grow-1" v-if="!loadingData">
                <div class="pt-2 pb-1 d-flex align-center">
                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Farms"
                            :persistent-placeholder="true"
                            :items="availableFarms"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-tractor"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedFarms"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedFarms, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedFarms || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Blocks"
                            :persistent-placeholder="true"
                            :items="availableBlocks"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-leaf"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedBlocks"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedBlocks, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedBlocks || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Varieties"
                            :persistent-placeholder="true"
                            :items="availableVarieties"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-apple"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedVarieties"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedVarieties, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedVarieties || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </div>

                <div class="py-2 d-flex align-center">
                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Teams"
                            :persistent-placeholder="true"
                            :items="availableTeams"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-account-group"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedTeams"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedTeams, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedTeams || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Employees"
                            :persistent-placeholder="true"
                            :items="availableEmployees"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-account-tie"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedEmployees"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedEmployees, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedEmployees || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                    <v-autocomplete
                            class="d-flex flex-grow-1 flex-equal px-1"
                            placeholder="All Devices"
                            :persistent-placeholder="true"
                            :items="availableDevices"
                            item-value="id"
                            item-text="description"
                            prepend-inner-icon="mdi-tablet-cellphone"
                            hide-details
                            dense
                            multiple
                            clearable
                            solo
                            v-model="selectedDevices"
                    >
                        <template #selection="{item}">
                            <v-chip
                                    small
                                    close
                                    @click:close="arrSplice(selectedDevices, val => val === item.id)"
                                    color="primary"
                            >
                                {{ item.description }}
                            </v-chip>
                        </template>
                        <template #item="{item, attrs, on}">
                            <v-list-item v-bind="attrs" v-on="on" selectable>
                                <v-list-item-avatar class="py-0 my-0"><v-icon>{{(selectedDevices || []).includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon></v-list-item-avatar>
                                <v-list-item-content><v-list-item-title v-text="item.description"/></v-list-item-content>
                                <v-list-item-action v-if="item.count">{{item.count}}</v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </div>
            </div>

            <app-loader v-if="loadingData" :size="32" class="fill-height d-flex align-center justify-center mx-3"/>
        </div>

        <v-card
                class="flex-grow-1"
                id="map"
                ref="map"
        ></v-card>
    </div>
</template>

<script>

import AppLoader from "@/components/General/Loader/Loader";
const southAfrica = { lat: -23.8833, lng: 30.4000};
import MarkerClusterer from '@googlemaps/markerclustererplus'
import { Loader } from "@googlemaps/js-api-loader"
import {arrSplice} from "@/core/codeFunctions";

export default {
    components: {AppLoader},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            loadingData: false,
            map: null,
            reportData: null,
            selectedFarms: null,
            selectedBlocks: null,
            selectedVarieties: null,
            selectedTeams: null,
            selectedEmployees: null,
            selectedDevices: null,
            markers: new Map(),
            arrSplice,
            selectedBin: null
        }
    },
    watch: {
        selectedDate: {
            handler(val) {
                this.getReportData()
            }
        },
        displayMarkers: {
            immediate: true,
            deep: true,
            handler(displayMarkers) {
                if (this.map) {

                    const visibleMarkers = []

                    this.markers.forEach(bin => {
                        if (displayMarkers.includes(bin.id)) {
                            visibleMarkers.push(bin.marker)
                            bin.marker.setMap(this.map)
                        }
                        else
                            bin.marker.setMap(null)
                    })

                    if (visibleMarkers.length) {
                        // eslint-disable-next-line no-undef
                        let latLngBounds = new google.maps.LatLngBounds();
                        visibleMarkers.forEach(marker => {
                            latLngBounds.extend(marker.position)
                        })

                        this.map.setCenter(latLngBounds.getCenter());
                        this.map.fitBounds(latLngBounds);
                    }
                }
            }
        }
    },
    mounted() {

        try {
            // eslint-disable-next-line no-undef
            const marker = new google.maps.Marker({
                position: {lat: 1, lng: 1},
                map: null,
                title: '',
            });
        } catch (e) {
            "GOTCHA"
            console.log(e)
        }
        this.initMap();
    },
    methods: {
        initMap() {
            const vm = this

            const loader = new Loader({
                apiKey: "AIzaSyC3_jW91qYjgRU02R4T_oXvXZ6X0ZyWXUk",
                version: "weekly",
            });
            //
            loader.load().then(() => {
                let mapEl = document.getElementById("map")
                // The map, centered at Uluru
                // eslint-disable-next-line no-undef
                const map = new google.maps.Map(mapEl, {
                    zoom: 6,
                    center: southAfrica,
                    mapTypeId: 'hybrid'
                });
                vm.map = map;
            });

            this.getReportData();
        },
        test() {
            const vm = this;
            [].forEach((position, i) => {
                // eslint-disable-next-line no-undef
                const arker = new google.maps.Marker({
                    position: position,
                    map: vm.map,
                    title: i.toString(),
                });

                // const contentString =
                //         `<div id="content">
                //         <div id="siteNotice">
                //         </div>
                //         <h2 id="firstHeading" class="firstHeading">${office.location}</h2>
                //         <div id="bodyContent" style="padding-top: 10px">
                //             <div style="max-width: 500px">
                //                 ${
                //                 office.brokers.map((broker) => {
                //                     return `<div style="display: inline-block; width: 240px; margin: 4px">
                //                     <div style="display: inline-block; box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); width: 46px; height: 46px; border-radius: 23px;">
                //                         <img src="${window.location.origin}/avatars/${broker.image || 'none.svg'}" width="46px" height="46px" style="border-radius: 23px;">
                //                     </div>
                //                     <div style="display: inline-block; padding-left: 10px; max-width: 190px">
                //                         <div style="font-size: 14px">
                //                             <b>${broker.title}</b>
                //                         </div>
                //                         <div style="font-size: 12px">
                //                             ${broker.number || ''}
                //                         </div>
                //                         <div style="font-size: 12px">
                //                             ${broker.email || ''}
                //                         </div>
                //                     </div>
                //                 </div>`
                //                 }).join('\n')
                //         }
                //             </div>
                //         </div>
                //         </div>`;
                // const infowindow = new google.maps.InfoWindow({
                //     content: contentString,
                // });
                //
                // office.infoWindow = infowindow
                //
                // infowindow.addListener("closeclick", () => {
                //     vm.selectedOffice = null
                // });
                //
                // office.marker.addListener("click", () => {
                //
                //     vm.offices.forEach(off => {
                //         if (off !== office)
                //             off.infoWindow.close()
                //     })
                //
                //     vm.markerClicked(office)
                //     infowindow.open({
                //         anchor: office.marker,
                //         map,
                //         shouldFocus: false,
                //     });
                // });
            })
        },
        async getReportData() {
            try {
                this.loadingData = true;
                this.reportData = await this.$newReq(
                        'POST',
                        `reports/mapsData`,
                        {
                            start: this.selectedDate,
                        },
                )
                this.reportData.forEach(bin => {
                    if (!this.markers.has(bin.id)) {
                        bin.marker = this.createMarkerForBin(bin)
                        this.markers.set(bin.id, bin)
                    }
                })

                if (this.reportData.length) {
                    // eslint-disable-next-line no-undef
                    let latLngBounds = new google.maps.LatLngBounds();
                    this.reportData.forEach(bin => {
                        latLngBounds.extend(bin.marker.position)
                    })

                    this.map.setCenter(latLngBounds.getCenter());
                    this.map.fitBounds(latLngBounds);
                }

            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingData = false
            }
        },
        createMarkerForBin(bin) {
            const vm = this;
            // eslint-disable-next-line no-undef
            const marker = new google.maps.Marker({
                position: bin.position,
                map: vm.map,
                title: bin.id.toString(),
            });

            const contentString =
                    `<div id="content">
                    <div id="siteNotice">
                    </div>
                    <h2 id="firstHeading" class="firstHeading">Bin ${bin.barcode}</h2>
                    <h3 id="firstHeading" class="firstHeading">${bin.capturedStr}</h3>
                    <div id="bodyContent" style="padding-top: 3px; min-width: 200px">

                        <table style="width: 100%">
                            <tr>
                                <td style="padding: 3px 5px 3px 0;">Farm:</td>
                                <td style="padding: 3px 0 3px 5px;"><b>${bin.farmDescription}</b></td>
                            </tr>
                            <tr>
                                <td style="padding: 0 5px 3px 0;">Block:</td>
                                <td style="padding: 0 0 3px 5px;"><b>${bin.blockDescription}</b></td>
                            </tr>
                            <tr>
                                <td style="padding: 0 5px 3px 0;">Variety:</td>
                                <td style="padding: 0 0 3px 5px;"><b>${bin.varietyDescription}</b></td>
                            </tr>
                            <tr>
                                <td style="padding: 0 5px 3px 0;">Team:</td>
                                <td style="padding: 0 0 3px 5px;"><b>${bin.teamDescription}</b></td>
                            </tr>
                            <tr>
                                <td style="padding: 0 5px 3px 0;">Device:</td>
                                <td style="padding: 0 0 3px 5px;"><b>${bin.deviceDescription}</b></td>
                            </tr>
                            <tr>
                                <td style="padding: 0 5px 3px 0;" colspan="2">Employees:</td>
                            </tr>
                        </table>

                        <table style="width: 100%; padding-left: 15px">

                        ${bin.employees.map(emp => {
                        return `<tr>
                                <td style="padding: 0 5px 3px 0;"><b>${emp.clockNo}</b></td>
                                <td style="padding: 0 0 3px 5px;"><b>${emp.fullName}</b></td>
                            </tr>`
                    })}
                        </table>
                    </div>
                    </div>`;



            // eslint-disable-next-line no-undef
            const infoWindow = new google.maps.InfoWindow({
                content: contentString,
            });

            bin.infoWindow = infoWindow

            infoWindow.addListener("closeclick", () => {
                vm.selectedBin = null
            });

            marker.addListener("click", () => {
                vm.openWindow(bin)
            });

            return marker
        },

        openWindow(bin) {

            console.log("OPEN", bin)
                this.markers.forEach(loopBin => {
                    if (loopBin.id !== bin.id)
                        loopBin.infoWindow.close()
                })
                // vm.markerClicked(office)
                bin.infoWindow.open({
                    anchor: bin.marker,
                    map: this.map,
                    shouldFocus: false,
                });
        }
    },
    computed: {
        availableFarms() {
            if (!this.reportData) {
                return []
            }
            const addedFarms = [];
            return this.reportData.reduce((list, bin) => {
                if (!addedFarms.includes(bin.fkFarm)) {
                    addedFarms.push(bin.fkFarm);
                    return list.concat(
                            {
                                id: bin.fkFarm,
                                description: bin.farmDescription,
                                count: this.reportData.filter(filterBin => {
                                    if (bin.fkFarm !== filterBin.fkFarm) return false
                                    if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${filterBin.fkFarm}-${filterBin.fkBlock}`)) return false
                                    if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(filterBin.fkVariety)) return false
                                    if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${filterBin.fkFarm}-${filterBin.team}`)) return false
                                    if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !filterBin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                                    if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(filterBin.fkDevice)) return false
                                    return true
                                }).length
                            }
                    )
                }
                return list
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        availableBlocks() {
            if (!this.reportData) {
                return []
            }
            const addedItems = [];
            return this.reportData.reduce((list, bin) => {
                const binKey = `${bin.fkFarm}-${bin.fkBlock}`
                if (!addedItems.includes(binKey)) {
                    addedItems.push(binKey);
                    return list.concat(
                            {
                                id: binKey,
                                description: bin.blockDescription,
                                count: this.reportData.filter(filterBin => {
                                    if (binKey !== `${filterBin.fkFarm}-${filterBin.fkBlock}`) return false
                                    if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(filterBin.fkFarm)) return false
                                    if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(filterBin.fkVariety)) return false
                                    if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${filterBin.fkFarm}-${filterBin.team}`)) return false
                                    if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !filterBin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                                    if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(filterBin.fkDevice)) return false
                                    return true
                                }).length
                            }
                    )
                }
                return list
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        availableVarieties() {
            if (!this.reportData) {
                return []
            }
            const addedItems = [];
            return this.reportData.reduce((list, bin) => {
                if (!addedItems.includes(bin.fkVariety)) {
                    addedItems.push(bin.fkVariety);
                    return list.concat(
                            {
                                id: bin.fkVariety,
                                description: bin.varietyDescription,
                                count: this.reportData.filter(filterBin => {
                                    if (bin.fkVariety !== filterBin.fkVariety) return false
                                    if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(filterBin.fkFarm)) return false
                                    if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${filterBin.fkFarm}-${filterBin.fkBlock}`)) return false
                                    if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${filterBin.fkFarm}-${filterBin.team}`)) return false
                                    if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !filterBin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                                    if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(filterBin.fkDevice)) return false
                                    return true
                                }).length
                            }
                    )
                }
                return list
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        availableTeams() {
            if (!this.reportData) {
                return []
            }
            const addedItems = [];
            return this.reportData.reduce((list, bin) => {
                const teamKey = `${bin.fkFarm}-${bin.team}`
                if (!addedItems.includes(teamKey)) {
                    addedItems.push(teamKey);
                    return list.concat(
                            {
                                id: teamKey,
                                description: bin.teamDescription,
                                count: this.reportData.filter(filterBin => {
                                    if (teamKey !== `${filterBin.fkFarm}-${filterBin.team}`) return false
                                    if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(filterBin.fkFarm)) return false
                                    if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(filterBin.fkVariety)) return false
                                    if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${filterBin.fkFarm}-${filterBin.fkBlock}`)) return false
                                    if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !filterBin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                                    if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(filterBin.fkDevice)) return false
                                    return true
                                }).length
                            }
                    )
                }
                return list
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        availableEmployees() {
            if (!this.reportData) {
                return []
            }
            const addedItems = [];
            return this.reportData.reduce((list, bin) => {

                const employees = bin.employees.reduce((empList, employee) => {
                    if (!addedItems.includes(employee.fkEmployee)) {
                        addedItems.push(employee.fkEmployee);
                        return empList.concat(
                                {
                                    id: employee.fkEmployee,
                                    description: `${employee.clockNo} - ${employee.fullName}`,
                                    count: this.reportData.filter(filterBin => {
                                        if (!filterBin.employees.map(emp => emp.fkEmployee).includes(employee.fkEmployee)) return false
                                        if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(filterBin.fkFarm)) return false
                                        if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${filterBin.fkFarm}-${filterBin.fkBlock}`)) return false
                                        if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${filterBin.fkFarm}-${filterBin.team}`)) return false
                                        if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(filterBin.fkVariety)) return false
                                        if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(filterBin.fkDevice)) return false
                                        return true
                                    }).length
                                }
                        )
                    }
                    return empList
                }, [])

                return list.concat(...employees)
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        availableDevices() {
            if (!this.reportData) {
                return []
            }
            const addedItems = [];
            return this.reportData.reduce((list, bin) => {
                if (!addedItems.includes(bin.fkDevice)) {
                    addedItems.push(bin.fkDevice);
                    return list.concat(
                            {
                                id: bin.fkDevice,
                                description: bin.deviceDescription,
                                count: this.reportData.filter(filterBin => {
                                    if (bin.fkDevice !== filterBin.fkDevice) return false
                                    if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(filterBin.fkFarm)) return false
                                    if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${filterBin.fkFarm}-${filterBin.fkBlock}`)) return false
                                    if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${filterBin.fkFarm}-${filterBin.team}`)) return false
                                    if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !filterBin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                                    if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(filterBin.fkVariety)) return false
                                    return true
                                }).length
                            }
                    )
                }
                return list
            }, []).sort((a,b) => {
                if (a.count === b.count)
                    return a.description > b.description ? 1 : -1
                return b.count - a.count
            })
        },
        displayMarkers() {
            if (!(Array.isArray(this.reportData) && this.reportData.length)) return []
            return this.reportData.filter(bin => {
                if (Array.isArray(this.selectedFarms) && this.selectedFarms.length && !(this.selectedFarms || []).includes(bin.fkFarm)) return false
                if (Array.isArray(this.selectedBlocks) && this.selectedBlocks.length && !(this.selectedBlocks || []).includes(`${bin.fkFarm}-${bin.fkBlock}`)) return false
                if (Array.isArray(this.selectedVarieties) && this.selectedVarieties.length && !(this.selectedVarieties || []).includes(bin.fkVariety)) return false
                if (Array.isArray(this.selectedTeams) && this.selectedTeams.length && !(this.selectedTeams || []).includes(`${bin.fkFarm}-${bin.team}`)) return false
                if (Array.isArray(this.selectedEmployees) && this.selectedEmployees.length && !bin.employees.find(employee => this.selectedEmployees.includes(employee.fkEmployee))) return false
                if (Array.isArray(this.selectedDevices) && this.selectedDevices.length && !(this.selectedDevices || []).includes(bin.fkDevice)) return false
                return true
            }).map(bin => bin.id)
        }
    }
}
</script>

<style scoped>

</style>